module.exports = __webpack_public_path__ + "static/media/shrimp.cea3d559.jpg";